/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button } from 'antd';
import { ImportOutlined } from '@ant-design/icons';
import { IBusinessUnit } from '@/interfaces/business-unit';
import { IDataModal } from '@/interfaces/dataModal';
import ImportFinancialMatchingModal from '@/components/import/financial-matching/import-matching-modal';

interface IProps {
  bus: IBusinessUnit[];
  onImported: () => void;
}

const _importModal: IDataModal<any> = {
  open: false,
};

const ImportExcel = ({ bus, onImported }: IProps) => {
  const [importModal, setImportModal] = useState<IDataModal<any>>({
    ..._importModal,
  });

  return (
    <div>
      <Button
        ghost
        type="primary"
        onClick={() => {
          setImportModal({
            open: true,
            id: 'coa',
          });
        }}
      >
        <ImportOutlined />
        Import Excel
      </Button>
      <ImportFinancialMatchingModal
        bus={bus || []}
        open={importModal?.open}
        handleOk={function (): void {
          setImportModal({ ..._importModal });
          onImported();
        }}
        handleCancel={function (): void {
          setImportModal({ ..._importModal });
        }}
      />
    </div>
  );
};

export default ImportExcel;
